import axios from "axios";
import toast from "react-hot-toast";
// 13.203.37.142
// export const BASE_URL ="https://api.oillogistics.co.in/api";
export const BASE_URL ="https://api.staging.oillogistics.co.in/api";

export const BASE_URL_IMAGE ="https://api.staging.oillogistics.co.in/";
//staging.oillogistics.co.in

const client = axios.create({
   baseURL: BASE_URL,
   // timeout: 60000, // 15 seconds timeout
   // timeoutErrorMessage: "Request timed out. Please try again.",
});

client.interceptors.request.use(async (config) => {
   // config.headers['Content-Type'] = 'application/json';
   // config.headers['Accept'] = 'application/json';

   // if (response) {
   //    const { token } = response;
   //    // config.headers['Authorization'] = `Bearer ${token}`;
   // }
   return config;
});

client.interceptors.response.use(
   (response) => {
      // Handle cases where the server returns 200 OK but the body contains an error status
      const { data } = response;
      if (data && data.statusCode && data.statusCode !== 200 && data.statusCode !== 201) {
         const message = data.errors
            ? Object.values(data.errors)?.[0]?.[0]
            : data.message;

         if (data.statusCode === 401) {
            toast.error(message || "Unauthorized. Please login again.");
            localStorage.removeItem("token");
            localStorage.removeItem("persist:root");
            if (window.location.pathname !== "/Login") {
               window.location.href = "/Login";
            }
         } else {
            toast.error(message || "Validation Error");
         }

         console.error("API Error (Success Block):", message, data);
         return Promise.reject(data);
      }
      return response;
   },
   (error) => {
      console.log("Response Interceptor Error:", error);
      if (error.response) {
         const { status, data } = error.response;

         // Validation error (422)
         if (status === 422) {
            const message = data.errors
               ? Object.values(data.errors)?.[0]?.[0]
               : data.message;
            toast.error(message || "Validation error");
            console.error("Validation Error (422):", message);
         }

         // Unauthorized
         else if (status === 401) {
            toast.error("Unauthorized. Please login again.");
            console.error("Unauthorized (401)");
            localStorage.removeItem("token");
            localStorage.removeItem("persist:root");
            if (window.location.pathname !== "/Login") {
               window.location.href = "/Login";
            }
         }

         // Server error
         else if (status === 500) {
            toast.error("Server error. Please try again later.");
            console.error("Server Error (500)");
         } else {
            const message = data?.message || "Something went wrong";
            toast.error(message);
            console.error(`API Error (${status}):`, message);
         }
      }

      // Network error
      else if (error.request) {
         toast.error("Network error. Please check your connection.");
         console.error("Network Error:", error.request);
      }

      return Promise.reject(error);
   },
);

export default client;
